import React from 'react';
import styled from 'styled-components';

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  color: inherit;
  text-align: left;

  &:hover {
    color: #0f2239;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 114, 0, 0.35);
    border-radius: 4px;
  }
`;

const Arrows = styled.span`
  display: inline-flex;
  flex-direction: column;
  line-height: 1;
  font-size: 8px;
  user-select: none;
`;

/**
 * Substitui @bit OrderContainer — mesma API (tag, current, sort, changeCurrent).
 */
const SortableColumnHeader = ({
  tag,
  current,
  sort,
  changeCurrent,
  children
}) => {
  const active = current === tag;
  const order = active ? sort : '';
  return (
    <Btn type="button" onClick={() => changeCurrent(tag)}>
      <span>{children}</span>
      <Arrows aria-hidden style={{ opacity: active ? 1 : 0.4 }}>
        <span style={{ opacity: order === 'ASC' ? 1 : 0.3 }}>▲</span>
        <span style={{ marginTop: -4, opacity: order === 'DESC' ? 1 : 0.3 }}>
          ▼
        </span>
      </Arrows>
    </Btn>
  );
};

export default SortableColumnHeader;
